import { useRouter } from 'next/router';
import React from 'react';
import HeaderMetaTags from '~/components/modules/Header/HeaderMetaTags';

import { AboutUsPageDark } from '~/components/views/AboutUs/AboutUsPageDark';
import AppContainer from '~/containers/AppContainer/AppContainer';

const AboutUs: React.FC = () => {
    const router = useRouter();
    return (
        <AppContainer>
            <HeaderMetaTags
                url={`${process.env.NEXT_PUBLIC_HOST_ENV}${router.asPath}`}
                title={'Get to know Vinovest and our investing platform | Vinovest'}
                type={'website'}
                description={
                    'Fine wine and whiskey have long been cornerstones of wealth generation and preservation. With data-driven strategies and a personalized platform, Vinovest makes building your portfolio simple.'
                }
                canonical
            />
            <AboutUsPageDark />
        </AppContainer>
    );
};

export default AboutUs;
